import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Button } from "@/components/ui/button";
import { Home, ArrowLeft } from "lucide-react";

const NotFoundPage = () => {
  return (
    <div data-testid="not-found-page" className="noise-overlay min-h-screen">
      <Helmet>
        <title>Page Not Found | Prithira Global</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <section className="pt-40 pb-32 bg-sand-200/30 min-h-screen flex items-center">
        <div className="container-custom">
          <div className="max-w-2xl mx-auto text-center">
            <span className="caption text-primary mb-4 block">404</span>
            <h1 className="heading-xl text-stone-900 mb-8">
              Page <span className="italic">Not Found</span>
            </h1>
            <p className="body-lg text-stone-600 mb-10">
              The page you're looking for doesn't exist or may have moved.
              Let's get you back on track.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/">
                <Button
                  data-testid="not-found-home-btn"
                  className="rounded-full px-8 py-6 text-base font-medium bg-primary text-primary-foreground hover:bg-primary/90 btn-lift"
                >
                  <Home className="mr-2 h-5 w-5" />
                  Back to Home
                </Button>
              </Link>
              <Link to="/products">
                <Button
                  data-testid="not-found-products-btn"
                  variant="outline"
                  className="rounded-full px-8 py-6 text-base font-medium border-2 border-primary text-primary hover:bg-primary/5"
                >
                  <ArrowLeft className="mr-2 h-5 w-5" />
                  View Products
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default NotFoundPage;
